// @ts-nocheck
import React from 'react'
import styled from 'styled-components'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router-dom'
import Button from '@material-ui/core/Button'
import TypographyPro from 'themes/TypographyPro'
import { respondAbove } from 'styles/mixins'
import ImageComponent from '../../../themes/ImageComponent'
import { getTranslatedTextByKey } from 'utils/utils'

const EmptyOrderContainer = styled.div`
	color: var(--fonts);
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 0 20px;

	${respondAbove.md`
		flex-direction: row;
    	align-items: unset;
		padding: unset;
	`}
`

const EmptyOrderButtonAndTextContainer = styled.div`
	width: 100%;
	margin-top: 32.5px;

	${respondAbove.md`
		margin-top: 30px;
		width: 411px;
	`}
`

const EmptyOrderImageStyled = styled(ImageComponent)`
	margin-top: 90px;
	max-width: 80vw;

	${respondAbove.md`
		max-width: 376px;
		margin-inline-start: 28px;
		margin-top: unset;
	`}
`
const StyledEmptyOrderText = styled(TypographyPro)``

const StyledButton = styled(Button)`
	color: var(--clear);
	border-radius: 2px;
	margin-top: 25px;
	background-color: var(--primary) !important;
	height: 45px;
	width: 100%;

	${respondAbove.md`
		margin-top: 61px;
		width: 411px;
		height: 56px;
	`}
`

export const EmptyOrder = ({ onClick }) => (
	<EmptyOrderContainer>
		<EmptyOrderButtonAndTextContainer>
			<StyledEmptyOrderText variant="SubheadHighlighted">{getTranslatedTextByKey('webviewFlow.noOrdersHere')}</StyledEmptyOrderText>
			<StyledEmptyOrderText variant="Subhead">{getTranslatedTextByKey('webviewFlow.noPastOrders')}</StyledEmptyOrderText>
			<StyledButton onClick={onClick} variant="contained">
				<TypographyPro variant="CTABig">{getTranslatedTextByKey('webviewFlow.browseMenu')}</TypographyPro>
			</StyledButton>
		</EmptyOrderButtonAndTextContainer>
		<EmptyOrderImageStyled asset="/images/pastOrdersEmpty.png" />
	</EmptyOrderContainer>
)

export default EmptyOrder
